import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  apiUrl: 'https://dev-alt-2-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-2-api.eshyft.com',
  firebaseTenantId: 'dev-alt-2-qi8u2',
}
